import { setCurrentSlide } from '../../actions/CurrentSlideActions';
import modeType from '../../constants/ModeConstants';
import { changeMode } from '../../actions/ProductionActions';
import storeManager from '../../store/StoreManager';
import appParameters from '../utils/AppParameters';
import configuration from '../../constants/Configuration';
import platformDetection from '../../components/utils/PlatformDetection';
import audioUtils from '../utils/AudioUtils';
import videoUtils from '../utils/VideoUtils';
import fullScreenManager from '../utils/FullScreenManager';
import playController from '../utils/PlayController';
import hoverManager from './HoverManager';
import audioVolumeUtils from './AudioVolumeUtils';
import animationManager from './AnimationManager';
import slidesPreloaderNew from './SlidesPreloaderNew';
import slidesPreloader from './SlidesPreloader';
import toolTipManager from './ToolTipManager';

const previewCommands = {
    fadeLimit: 4000, // 4 seconds
    isPlaying: false,
    refreshFunction: undefined,
    storySoundVolume: 0.5,
    forceUpdateForPlayButton: undefined,

    changeSlideVar: undefined,
    playbackPositionVar: undefined,
    totalTime: 0,
    startTime: 0,

    getDispatch() {
        const store = storeManager.getStore();
        return store.dispatch;
    },
    isEditorMode () {
        const state = storeManager.getState();
        const previewMode = state.production.mode;

        if (previewMode == modeType.EDITOR)
            return true;
        else
            return false;
    },
    isPlayMode() {
        if (this.isEditorMode() == false || appParameters.getMode() == modeType.PLAYER)
            return true;
        else
            return false;
    },
    isPlayer() {
        if (appParameters.getMode() == modeType.PLAYER)
            return true;
        else
            return false;
    },
    goToFirstSlide(enterPreviewMode = false) {
        const state = storeManager.getState();
        const slideIndex = state.currentSlide.currentSlideIndex;

        if (slideIndex != 0)
            this.changeSlideToIndex(0);
        else {
            if (enterPreviewMode) {
                if (!playController.isAudioEditorAvailable())
                    this.loadSlideSound(slideIndex);
            }
        }
    },
    goToSlideIndex (index) {
        const dispatch = this.getDispatch();
        dispatch(setCurrentSlide(index));

        if (playController.isAudioEditorAvailable()) {
            this.isPlaying = false;
        } else {
            if (this.isPlaying == true) {
                this.isPlaying = false;
                this.playPauseStorySound();
            } else
                this.loadSlideSound(index);
        }
    },
    changeSlideToIndex (index) {
        const dispatch = this.getDispatch();
        dispatch(setCurrentSlide(index));

        if (!playController.isAudioEditorAvailable())
            this.loadSlideSound(index);
    },
    setCoreProperties(id) {
        var element = document.getElementById(id);

        if (!element)
            return;

        element.setAttribute('crossOrigin', 'anonymous');
    },
    getStorySound() {
        const audio = document.getElementById('storySound');

        if (!(this.storySoundVolume >= 0 && this.storySoundVolume <= 1))
            this.storySoundVolume = 0.5;

        if (audio && !platformDetection.isIOS())
            audio.volume = this.storySoundVolume;

        return audio;
    },
    isAudioAvailable(audio) {
        if (audio) {
            const readyState = audio.readyState;
            const networkState = audio.networkState;

            if (readyState == 0 || networkState == 3)
                return false;
            else
                return true;
        } else
            return false;
    },
    clearOffSet() {
        this.playTime = -1;
        this.pauseTime = -1;
        this.lastPausedSlideIndex = -1;
        this.oldOffset = 0;
    },
    executeCommand (type, volume) {
        if (this.isPlaying && (type == 0 || type == 1 || type == 3 || type == 4)) // if is playing then you can change the slide position ... back,forward, first, end
            return;

        const state = storeManager.getState();
        const slides = state.production.slides;
        const currentIndex = state.currentSlide.currentSlideIndex;

        if (!playController.isAudioEditorAvailable()) {
            if (volume == undefined)
                volume = 0.5;

            this.storySoundVolume = volume;
        }

        switch (type) {
            case 0: {
                if (currentIndex > 0) {
                    this.clearOffSet();
                    this.goToSlideIndex(0);

                    if (playController.isAudioEditorAvailable())
                        playController.resetPropertiesForPreview();
                    else
                        this.clearPreview();
                }
                break;
            }
            case 1: {
                if (currentIndex > 0) {
                    this.clearOffSet();
                    this.goToSlideIndex(currentIndex - 1);

                    if (playController.isAudioEditorAvailable())
                        playController.resetPropertiesForPreview();
                    else
                        this.clearPreview();
                }
                break;
            }
            case 2: {
                if (playController.isAudioEditorAvailable())
                    this.playSequence();
                else
                    this.playPauseStorySound(true);
                break;
            }
            case 3: {
                if (currentIndex < (slides.length - 1)) {
                    this.clearOffSet();
                    this.goToSlideIndex(currentIndex + 1);

                    if (playController.isAudioEditorAvailable())
                        playController.resetPropertiesForPreview();
                    else
                        this.clearPreview();
                }
                break;
            }
            case 4: {
                if (currentIndex != (slides.length - 1)) {
                    this.clearOffSet();
                    this.goToSlideIndex(slides.length - 1);

                    if (playController.isAudioEditorAvailable())
                        playController.resetPropertiesForPreview();
                    else
                        this.clearPreview();
                }
                break;
            }
            case 5: {
                this.clearOffSet();
                if (appParameters.getMode() == modeType.PLAYER) {
                    fullScreenManager.goFullScreenMode();
                } else {
                    this.exitPreview();
                }
                break;
            }
        }
    },
    goFullScreenMode() {
        fullScreenManager.goFullScreenMode();
    },
    playSequence() {
        if (this.isPlaying == false) {
            this.isPlaying = true;
            playController.play(true);
        } else {
            this.isPlaying = false;
            playController.pause();
        }
    },
    endSequence() {
        if (this.refreshFunction)
            this.refreshFunction();
    },
    initSequence() {
        playController.endSequenceCallback = this.endSequence;
    },
    slideDurationOffset() {
        var ipadOffset = 0;

        // if (platformDetection.isIOS() == true)
        //     ipadOffset = 1;

        return ipadOffset;
    },
    getSlideDuration(value) {
        var ipadOffset = this.slideDurationOffset();

        if (value == undefined)
            return configuration.SLIDE_DURATION + ipadOffset;
        else
            return value + ipadOffset;
    },
    exitPreview() {
        this.clearOffSet();
        previewCommands.isPlaying = false;

        animationManager.exitPreview();

        if (playController.isAudioEditorAvailable()) {
            playController.changeMode();
        } else {
            this.pauseStorySound(true);
            this.clearPreview();
        }

        const dispatch = this.getDispatch();
        dispatch(changeMode(modeType.EDITOR));

        videoUtils.updateStartPoint();

        if (videoUtils.isVideoShapes())
            videoUtils.playPauseVideoShapes(false, true);

        hoverManager.hide();

        if (playController.isAudioEditorAvailable())
            slidesPreloaderNew.exitPreview();
        else
            slidesPreloader.exitPreview();
    },
    clearPreview() {
        if (platformDetection.isIOS() == false)
            this.clearFadeOutTimer();

        if (this.changeSlideVar)
            clearTimeout(this.changeSlideVar);

        if (this.refreshFunction)
            this.refreshFunction();

        animationManager.stopAnimations();
        toolTipManager.resetToolTip();
    },
    getPlayOffset(isAction, slideIndex) {
        if (!isAction)
            return 0;

        var videoSource = this.getSlideVideoSource(slideIndex);

        if (videoSource && videoSource.length > 0)
            return videoUtils.getPlayOffset();
        else  //TODO: take into consideration the audio offset if the current slide has no video
            return 0;
    },
    getPreviousSlidesOffset() {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var currentIndex = state.currentSlide.currentSlideIndex;
        var i;
        var offsetTime = 0;

        for (i=0; i<currentIndex; i++)
            offsetTime = offsetTime + slides[i].time;

        return offsetTime;
    },

    playTime: -1,
    pauseTime: -1,
    lastPausedSlideIndex: -1,
    oldOffset: 0,

    playPauseStorySound(isAction = false) {
        const playState = this.isPlaying;
        const state = storeManager.getState();

        if (playState == false) {
            var currentSlideTime = state.currentSlide.model.time;
            var playOffset = 0;

            this.isPlaying = true;

            if (isAction && this.playTime > 0 && this.pauseTime > 0 && this.pauseTime > this.playTime && state.currentSlide.currentSlideIndex == this.lastPausedSlideIndex) {
                playOffset = (this.pauseTime - this.playTime) / 1000;
                playOffset = Number(playOffset.toFixed(2));

                if (this.oldOffset >= 0)
                    playOffset = playOffset + this.oldOffset;

                if (playOffset >= currentSlideTime) {
                    playOffset = 0;
                    this.oldOffset = 0;
                } else
                    this.oldOffset = playOffset;
            }

            this.playTime = new Date().getTime();

            this.playStorySound(this.getPreviousSlidesOffset() + playOffset);
            this.loadSlideSound(state.currentSlide.currentSlideIndex, playOffset);

            this.changeSlideVar = setTimeout(this.goToNextSlide.bind(this), this.getSlideDuration(currentSlideTime) * 1000 - playOffset * 1000);

            if (!platformDetection.isIOS())
                this.checkFade();
        } else {
            if (isAction) {
                this.pauseTime = new Date().getTime();
                this.lastPausedSlideIndex = state.currentSlide.currentSlideIndex;
                this.endPlayStorySound(state.currentSlide.currentSlideIndex);
            } else
                this.endPlayStorySound();
        }
    },
    endPlayStorySound(excludedVideo = -1) {
        if (!platformDetection.isIOS())
            this.clearFadeOutTimer();

        animationManager.stopAnimations();

        this.isPlaying = false;
        this.pauseStorySound(excludedVideo === -1);
        this.stopSlideSounds();
        videoUtils.refreshVideosInPlayMode(excludedVideo);

        if (this.refreshFunction)
            this.refreshFunction();
    },
    getPlaySoundPosition() {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const currentIndex = state.currentSlide.currentSlideIndex;
        var totalTime = 0;
        var i;
        var slide;

        for (i=0; i<currentIndex; i++) {
            slide = slides[i];

            totalTime = totalTime + slide.time;
        }

        return totalTime;
    },
    playStorySound(offset = 0) {
        this.storySoundOperation('play', offset);
    },
    checkVideoStartPosition() {
        var video = videoUtils.getCurrentVideo();

        if (video && video.currentSrc && video.currentSrc.length > 0)
            video.currentTime = videoUtils.getStartPoint();
    },
    pauseStorySound(resetVideo = false) {
        if (platformDetection.isIOS() == false)
            this.clearFadeOutTimer();

        if (this.changeSlideVar)
            clearTimeout(this.changeSlideVar);

        this.storySoundOperation('pause');

        if (audioVolumeUtils.useVolumeFunctionality()) {
            audioVolumeUtils.executeMediaAction('slideSound', 0, false);
            audioVolumeUtils.executeMediaAction('slideSoundEffect', 0, false);
        } else {
            audioUtils.pauseSound('slideSound');
            audioUtils.pauseSound('slideSoundEffect');
        }

        animationManager.stopAnimations();
        videoUtils.pauseVideoPreview(resetVideo);

        if (!videoUtils.isVideoBackground() && videoUtils.isVideoShapes())
            videoUtils.pauseVideoShapesPreview(resetVideo);
    },
    endStorySound() {
        this.storySoundOperation('restart');
    },
    isPlayingAudio(audio) {
        var isPlaying = audio.currentTime > 0 && !audio.paused && !audio.ended && audio.readyState > 2;

        return isPlaying;
    },
    storySoundOperation(state, offsetTime = 0) {
        var audio = this.getStorySound();

        if (!audioVolumeUtils.useVolumeFunctionality() && this.isAudioAvailable(audio) == false)
            return;

        switch (state) {
            case 'play': {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('storySound', this.storySoundVolume, true, this.endStorySound);
                else {
                    audio.currentTime = offsetTime;
                    audioUtils.playSound('storySound');
                }
                break;
            }

            case 'pause': {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('storySound', 0, false);
                else
                    audioUtils.pauseSound('storySound', true);
                break;
            }

            case 'restart': {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('storySound', 0, false);
                else {
                    audio.currentTime = 0;
                    audioUtils.playSound('storySound');
                }
                break;
            }
        }
    },
    goToNextSlide () {
        if (this.isPlaying == false || this.isEditorMode() == true)
            return;

        const state = storeManager.getState();
        const slides = state.production.slides;
        const currentIndex = state.currentSlide.currentSlideIndex;

        if (this.isPlaying) {
            this.playTime = new Date().getTime();
            this.oldOffset = 0;
        }

        if (currentIndex < (slides.length - 1)) {
            const nextSlide = slides[currentIndex + 1];
            this.changeSlideToIndex(currentIndex + 1);
            this.changeSlideVar = setTimeout(this.goToNextSlide.bind(this), this.getSlideDuration(nextSlide.time) * 1000);
        }
        else {
            this.endPlayStorySound();
        }
    },
    // Slide Sound functionality
    getSlideSoundSource(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var audio;

        if (slides[index].soundWav)
            audio  = slides[index].soundWav;
        else
            audio  = slides[index].sound;

        if (audio && audio.length > 0)
            return audio;
        else
            return '';
    },
    getSlideSoundEffectSource(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var audio = slides[index].soundEffect;

        if (audio && audio.length > 0)
            return audio;
        else
            return '';
    },
    loadSlideSound(index, playOffset = 0) {
        this.loadSlideVideo(index, playOffset);

        if (this.isPlaying == false)
            return;

        this.stopSlideSounds();

        // Slide Sound
        const audioSource = this.getSlideSoundSource(index);

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.loadAndPlaySound(audioSource, 'slideSound', audioUtils.getSoundVolume('slideSound'));
        else {
            audioUtils.setSoundVolume('slideSound');
            audioUtils.playSlideSoundFromUrl(audioSource, playOffset);
        }

        // Slide Sound Effect
        const audioEffectSource = this.getSlideSoundEffectSource(index);

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.loadAndPlaySound(audioEffectSource, 'slideSoundEffect', audioUtils.getSoundVolume('slideSoundEffect'));
        else {
            audioUtils.setSoundVolume('slideSoundEffect');
            audioUtils.playSlideSoundEffectFromUrl(audioEffectSource, playOffset);
        }

        animationManager.startAnimations(false, playOffset * 1000);
    },
    stopSlideSounds() {
        if (audioVolumeUtils.useVolumeFunctionality()) {
            audioVolumeUtils.executeMediaAction('slideSound', 0, false);
            audioVolumeUtils.executeMediaAction('slideSoundEffect', 0, false);
        } else {
            audioUtils.pauseSound('slideSound', true);
            audioUtils.pauseSound('slideSoundEffect', true);
        }
    },
    getSlidesText() {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var index = state.currentSlide.currentSlideIndex + 1;

        if (index > slides.length)
            index = slides.length;

        return index + ' / ' + slides.length;
    },

    // Slide video functionality
    getHostName() {
        if (configuration.IS_PROD())
            return 'https://www.creaza.com';
        else
            return 'https://stage.creaza.com';
    },
    getCorrectUrl(url) {
        var newUrl = '';

        if (url && url.indexOf('file/ci') != -1) {
            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1)
                newUrl = this.getHostName();

            newUrl = newUrl + url;
        } else {
            newUrl = url;
        }

        return newUrl;
    },
    getSlideVideoSource(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const background = slides[index].content[0];
        var videoSource = '';

        if (background.isVideo)
            videoSource = background.xlinkHref;

        if (videoSource && videoSource.length > 0)
            return this.getCorrectUrl(videoSource);
        else
            return '';
    },
    loadSlideVideo(index, playOffset = 0) {
        videoUtils.playVideoFromSlideIndex(index, playOffset, this.isPlaying);
    },
    // FADE OUT functionality
    fadeOutAudio(percentVolume) {
        const storySound = document.getElementById('storySound');

        if (storySound)
            storySound.volume = this.storySoundVolume * percentVolume;

        //const slideSound = document.getElementById('slideSound');
        //slideSound.volume = 1 * percentVolume;
    },
    resetFadeOut() {
        const storySound = document.getElementById('storySound');

        if (storySound && this.storySoundVolume > -1)
            storySound.volume = this.storySoundVolume;

        //const slideSound = document.getElementById('slideSound');
        //slideSound.volume = 1;
    },
    getFadeVolume(remainingTime) {
        if (remainingTime < 0 || remainingTime > this.fadeLimit)
            return 0;

        var value = remainingTime / this.fadeLimit;

        return value;
    },
    checkFade() {
        this.clearFadeOutTimer();

        const state = storeManager.getState();
        const slides = state.production.slides;
        const currentIndex = state.currentSlide.currentSlideIndex;
        var totalTime = 0;
        var i;
        var slide;
        var offset = this.slideDurationOffset();

        for (i=currentIndex; i<slides.length; i++) {
            slide = slides[i];

            totalTime = totalTime + slide.time + offset;
        }

        this.totalTime = totalTime * 1000;

        var date = new Date();
        this.startTime = date.getTime();
        this.playbackPositionVar = setInterval(this.checkPlaybackPosition.bind(this), 100);

        this.checkPlaybackPosition();
    },
    checkPlaybackPosition() {
        var date = new Date();
        const currentTime = date.getTime();
        const playTime = currentTime - this.startTime;
        const remainingTime = this.totalTime - playTime;

        if (remainingTime <= this.fadeLimit) {
            this.fadeOutAudio(this.getFadeVolume(remainingTime));
        }
    },
    clearFadeOutTimer() {
        if (this.playbackPositionVar)
            clearInterval(this.playbackPositionVar);

        this.resetFadeOut();
    }
};

export default previewCommands;



/** WEBPACK FOOTER **
 ** ./src/components/utils/PreviewCommands.js
 **/